import { todayTokyoDateInput } from "./date";

export interface ReservationFormValues {
  pcId: number | null;
  userId: number | null;
  startDate: string;
  endDate: string;
  purpose: string;
  notes: string;
}

export function validateReservationForm(
  values: ReservationFormValues,
  startIso: string,
  endIso: string
): string | null {
  if (!values.pcId) return "使用PCを選択してください。";
  if (!values.userId) return "使用者を選択してください。";
  if (!values.startDate) return "利用開始日を入力してください。";
  if (!values.endDate) return "利用終了日を入力してください。";

  const start = new Date(startIso).getTime();
  const end = new Date(endIso).getTime();
  if (start >= end) return "利用開始日時は利用終了日時より前である必要があります。";
  // Compares calendar dates, not exact instants, so "today" is always valid
  // regardless of the current time (reservations run a fixed 9:00-18:00).
  if (values.startDate < todayTokyoDateInput()) return "過去の日付は選択できません。";
  if (values.purpose.length > 200) return "利用目的は200文字以内で入力してください。";
  if (values.notes.length > 1000) return "備考は1000文字以内で入力してください。";
  return null;
}

export function validateReturnNotes(notes: string): string | null {
  if (notes.length > 1000) return "返却備考は1000文字以内で入力してください。";
  return null;
}
